import { ActionReducerMap } from '@ngrx/store';
import { informationBarReducer, initialAppState } from './core/reducers/informationBar.reducer';
import { initialTraceState, traceReducer } from './trace-management/core/reducers/trace.reducer';
import { initialViewerState, viewerReducer } from './trace-management/core/reducers/viewer.reducer';
import { environmentReducer, initialEnvAppState } from './core/reducers/environment.reducer';
import { bzAlertReducer, initialAppAlertState } from './shared/components/alert/core/reducers/alert.reducer';
import { initialProfileState, profileReducer } from './core/reducers/profile.reducer';
import { initialOptionsState, optionsReducer } from './core/reducers/options.reducer';
import { configReducer, initialConfigState } from './core/reducers/config.reducer';
import { MigrateReducer, initialMigrateStakeholdersState } from "./migrate-stakeholders/store/reducers/migrate.reducer";
import { IAppState } from './IAppState';


export const INITIAL_STATE: IAppState = {
  informationBarState: initialAppState,
  stateViewer: initialViewerState,
  stateTrace: initialTraceState,
  bzAlertState: initialAppAlertState,
  environmentState: initialEnvAppState,
  profile: initialProfileState,
  menuOptions: initialOptionsState,
  config: initialConfigState,
  migrateStakeholders: initialMigrateStakeholdersState
};

export const ROOT_REDUCER: ActionReducerMap<IAppState> = {
  informationBarState: informationBarReducer,
  stateTrace: traceReducer,
  stateViewer: viewerReducer,
  environmentState: environmentReducer,
  bzAlertState: bzAlertReducer,
  profile: profileReducer,
  menuOptions: optionsReducer,
  config: configReducer,
  migrateStakeholders: MigrateReducer
};

